import axiosClient from "./axiosClient";

export interface UploadCarouselParams {
  title: string;
  image: File;
}

export const CAROUSEL_KEY = ["carousel"];

const carouselApi = {
  uploadCarousel: async (data: UploadCarouselParams) => {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("image", data.image);

    const res = await axiosClient.post("/carousel", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    });

    return res;
  },

  getCarousel: async () => {
    const res = await axiosClient.get("/carousel");
    return res;
  },

  updateCarousel: async (id: string, data: UploadCarouselParams) => {
    const formData = new FormData();

    formData.append("title", data.title);

    if (data.image) {
      formData.append("image", data.image);
    }

    const res = await axiosClient.put(`/carousel/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    });

    return res;
  },

  deleteCarousel: async (id: string) => {
    const res = await axiosClient.delete(`/carousel/${id}`, {
      withCredentials: true,
    });
    return res;
  },
};

export default carouselApi;